import * as ActionTypes from "./actionTypes";

export function loadPages(expId) {
	return { type: ActionTypes.LOAD_PAGES, expId };
}

export function loadPagesSuccess(pages) {
	return { type: ActionTypes.LOAD_PAGES_SUCCESS, pages };
}

export function loadPagesFail(errorMessage) {
	return { type: ActionTypes.LOAD_PAGES_FAIL, errorMessage };
}

export function createPage(page, expId) {
	return { type: ActionTypes.CREATE_PAGE, page, expId };
}

export function createPageSuccess(expId) {
	return { type: ActionTypes.CREATE_PAGE_SUCCESS, expId };
}

export function createPageFail(errorMessage) {
	return { type: ActionTypes.CREATE_PAGE_FAIL, errorMessage };
}

export function selectPage(page) {
	return { type: ActionTypes.SELECT_PAGE, page };
}

export function selectPageSuccess(page) {
	return { type: ActionTypes.SELECT_PAGE_SUCCESS, page };
}

export function resetCurrentPage() {
	return { type: ActionTypes.RESET_CURRENT_PAGE };
}

export function selectPageFailure(errorMessage) {
	return { type: ActionTypes.SELECT_PAGE_FAILURE, errorMessage };
}

export function editPage(id, page, expId) {
	return { type: ActionTypes.EDIT_PAGE, id, page, expId };
}

export function editPageSuccess(expId) {
	return { type: ActionTypes.EDIT_PAGE_SUCCESS, expId };
}

export function editPageFailure(errorMessage) {
	return { type: ActionTypes.EDIT_PAGE_FAILURE, errorMessage };
}

export function deletePage(page, expId) {
	return { type: ActionTypes.DELETE_PAGE, page, expId };
}

export function deletePageSuccess(expId) {
	return { type: ActionTypes.DELETE_PAGE_SUCCESS, expId };
}

export function deletePageFailure(errorMessage) {
	return { type: ActionTypes.DELETE_PAGE_FAILURE, errorMessage };
}

export function setChatPages(chatPages) {
	return { type: ActionTypes.SET_CHAT_PAGES, chatPages };
}

export function setPollingPages(pollingPages) {
	return { type: ActionTypes.SET_POLLING_PAGES, pollingPages };
}
